import { DropdownMenuItem, NestedDropdown } from '@/components/DropdownMenu'
import { StrikedEye } from '@/icons'
import { CircularProgress } from '@mui/material'

import { ActiveIcon } from '../ActiveIcon'
import { useTexts } from './useTexts'

import { useActions } from './hooks/useActions'
import { useHasRoutePaths } from './hooks/useHasRoutePaths'
import { useRoutePathsMapStyle } from './hooks/useRoutePathsMapStyle'
interface Props {
  parentOpen: boolean
}
export function RoutePathsSubMenu(props: Props) {
  const { parentOpen } = props

  const {
    methodInExecution,
    actions: { showRoutePaths, hideRoutePaths, showRoutePathsWithDirections },
  } = useActions()
  const activeStyle = useRoutePathsMapStyle()

  const hasRoutePaths = useHasRoutePaths()
  const texts = useTexts()

  // TODO: Disabled for v3-beta release
  // const tooltipTitle = hasRoutePaths === true ? undefined : texts.noRoutePaths

  return (
    <NestedDropdown
      placement="left"
      parentOpen={parentOpen}
      disabled={!hasRoutePaths}
      triggerContent={texts.routePaths}
      Icon={
        hasRoutePaths && activeStyle === 'off' ? (
          <StrikedEye size={12} color="$silver" />
        ) : undefined
      }
    >
      <DropdownMenuItem
        external
        onClick={showRoutePaths}
        Icon={
          methodInExecution === 'showRoutePaths' ? (
            <span style={{ marginRight: 10 }}>
              <CircularProgress size={12} color="primary" />
            </span>
          ) : (
            <ActiveIcon active={activeStyle === 'on'} />
          )
        }
      >
        {texts.on}
      </DropdownMenuItem>

      <DropdownMenuItem
        external
        onClick={showRoutePathsWithDirections}
        Icon={
          methodInExecution === 'showRoutePathsWithDirections' ? (
            <span style={{ marginRight: 10 }}>
              <CircularProgress size={12} color="primary" />
            </span>
          ) : (
            <ActiveIcon active={activeStyle === 'withDirections'} />
          )
        }
      >
        {texts.onWithDirections}
      </DropdownMenuItem>

      <DropdownMenuItem
        external
        onClick={hideRoutePaths}
        Icon={
          methodInExecution === 'hideRoutePaths' ? (
            <span style={{ marginRight: 10 }}>
              <CircularProgress size={12} color="primary" />
            </span>
          ) : (
            <ActiveIcon active={activeStyle === 'off'} />
          )
        }
      >
        {texts.off}
      </DropdownMenuItem>
    </NestedDropdown>
  )
}
